import React from 'react';

import PowerIcon from '@material-ui/icons/Power';
import PowerOffIcon from '@material-ui/icons/PowerOff';

export const DeviceChargingIndicator = ({ charging }: { charging: boolean }) => {
  return charging ? (
    <PowerIcon fontSize='small' style={{color: 'rgb(74 74 74)'}} />
  ) : 
  (
    <PowerOffIcon fontSize='small' style={{color: 'rgb(74 74 74)'}} />
  );
}